import React, { ReactElement } from "react";

import { NavWrapper, NavItem, NavLink } from "./styled";
import { TabProps, TabsProps } from "./types";

const TabsNav = ({ tabs }: TabsProps): ReactElement => {
  return (
    <NavWrapper>
      <ul className="nav nav-tabs">
        {tabs.map((tab: TabProps) => (
          <NavItem className="nav-item" key={tab.key}>
            <NavLink
              className={`nav-link${
                tab.isSelected && tab.content ? " active" : ""
              }`}
              onClick={tab.onSelect}
              isSelected={tab.isSelected}
            >
              {tab.label}
            </NavLink>
          </NavItem>
        ))}
      </ul>
    </NavWrapper>
  );
};

export default TabsNav;
